// ============================================================
// src/core/errors.js
// Manejo centralizado de errores del proyecto
// ============================================================

import { mostrarToast } from '../ui.js';
import { logError } from './logger.js';

const MENSAJES_FIREBASE = {
  'auth/user-not-found': 'No existe una cuenta con ese correo.',
  'auth/wrong-password': 'La contraseña es incorrecta.',
  'auth/invalid-credential': 'Las credenciales no son válidas.',
  'auth/email-already-in-use': 'Ese correo ya está en uso.',
  'auth/invalid-email': 'El correo no es válido.',
  'auth/weak-password': 'La contraseña es demasiado débil.',
  'auth/popup-closed-by-user': 'Se cerró la ventana de acceso antes de completar el inicio de sesión.',
  'auth/cancelled-popup-request': 'La solicitud de acceso fue cancelada.',
  'auth/popup-blocked': 'El navegador bloqueó la ventana emergente de acceso.',
  'auth/requires-recent-login': 'Por seguridad, vuelve a iniciar sesión antes de realizar esta acción.',
  'auth/network-request-failed': 'No se pudo conectar. Revisa tu conexión a internet.',

  'permission-denied': 'No tienes permisos para realizar esta acción.',
  'not-found': 'No se encontró la información solicitada.',
  'already-exists': 'El elemento ya existe.',
  'failed-precondition': 'No se puede completar la acción en el estado actual.',
  'unavailable': 'El servicio no está disponible en este momento.',
};

function _obtenerCodigo(error) {
  if (!error) return '';
  if (typeof error === 'string') return error;
  return error.code || error.status || error.name || '';
}

export function obtenerMensajeError(error, fallback = 'Ocurrió un error inesperado.') {
  const codigo = _obtenerCodigo(error);

  if (codigo && MENSAJES_FIREBASE[codigo]) {
    return MENSAJES_FIREBASE[codigo];
  }

  if (error?.message && typeof error.message === 'string') {
    return error.message;
  }

  return fallback;
}

export function manejarError(error, contexto = 'General', opciones = {}) {
  const {
    mostrar = true,
    fallback = 'Ocurrió un error inesperado.',
    detalle = null,
  } = opciones;

  const mensaje = obtenerMensajeError(error, fallback);

  logError(contexto, mensaje, {
    error,
    detalle,
    codigo: _obtenerCodigo(error),
  });

  if (mostrar) {
    mostrarToast(mensaje, 'error');
  }

  return mensaje;
}

export function esErrorCodigo(error, codigo) {
  return _obtenerCodigo(error) === codigo;
}